import React from 'react';
import { Circle, MapPin, Database } from 'lucide-react';
import { useConnectionStatus } from '../../../hooks/useConnectionStatus';
import { useLocationTracking } from '../../../hooks/useLocationTracking';
import { useSurvey } from '../../../contexts/SurveyContext';

const RecordingStatusToast = () => {
  const { status: connectionStatus } = useConnectionStatus();
  const { locationStatus, hasSignal } = useLocationTracking();
  const { activeSurvey } = useSurvey();

  if (!activeSurvey) return null;

  // Get status colors
  const getLocationStatusColor = () => {
    if (!hasSignal || locationStatus === 'error') return 'text-red-500';
    if (locationStatus === 'checking') return 'text-yellow-500';
    return 'text-green-500';
  };

  const getDatabaseStatusColor = () => {
    switch (connectionStatus) {
      case 'online':
        return 'text-green-500';
      case 'pending':
        return 'text-yellow-500';
      case 'offline':
      case 'error':
        return 'text-red-500';
      default:
        return 'text-gray-500';
    }
  };

  const getDatabaseStatusText = () => {
    switch (connectionStatus) {
      case 'online':
        return 'Connected';
      case 'pending':
        return 'Offline Mode';
      case 'offline':
        return 'Offline';
      case 'error':
        return 'Error';
      default:
        return 'Unknown';
    }
  };

  return (
    <div className="absolute top-2 right-2 bg-gray-800/90 backdrop-blur text-white px-3 py-1.5 rounded-lg shadow-lg flex items-center gap-3 text-xs">
      {/* Recording Status */}
      <div className="flex items-center gap-1.5">
        <Circle className="w-2.5 h-2.5 animate-pulse text-red-500" />
        <span>Recording</span>
      </div>

      {/* Location Status */}
      <div className="h-2.5 w-px bg-white/20" />
      <div className="flex items-center gap-1.5">
        <MapPin className={`w-2.5 h-2.5 ${getLocationStatusColor()}`} />
        <span>Location</span>
      </div>

      {/* Database Status */}
      <div className="h-2.5 w-px bg-white/20" />
      <div className="flex items-center gap-1.5">
        <Database className={`w-2.5 h-2.5 ${getDatabaseStatusColor()}`} />
        <span>{getDatabaseStatusText()}</span>
      </div>
    </div>
  );
};

export default RecordingStatusToast;
export { RecordingStatusToast };